<template>

  <div class="wrap">

    <div class="page-header">
        <Nav :activeId="activeId" />
    </div>

    <!-- 头 -->
    <div class="section-one">
      <img src="../../img/product-4/banner.jpg" />

      <div class="nav-bar">
        <div class="nav-bar_label">PRODUCTS AND TECHNOLOGY</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>产品与技术</span>全屋活水解決方案
        </div>
        <!-- <img src="../../img/product-4/nav-top.png" class="product p-4" /> -->
      </div>

      <!-- <img src="../../img/product-4/title.png" class="v-c-title product-4-title" /> -->
    </div>

    <!-- 尾 -->
    <div class="section-one bg-info">
      <!-- <img src="../../img/product-4/bg1.jpg" class="bg" /> -->
      <div class="product-4-info">
        <img src="../../img/product-4/bg1-info2.png" class="" />
      </div>
    </div>

    <Footer />
  </div>

</template>

<script>
// import $ from 'jquery'
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 1
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
    // $('.nav-btm-line').css({
    //   left: 220 + 'px'
    // });
  }
};
</script>

<style scoped lang="less">
.bg-info {
  background-color: #F0F0F0;
  // height: 1881px;
  padding: 150px 0 250px;
}
</style>